import { useCustomTranslation } from '../../../Hooks/useCustomTranslation'
import { Day } from '../types'

interface UseWeekdayHook {
  translatedWeekdaysShort: Record<Day, string>
  translatedWeekdaysLong: Record<Day, string>
}

export const useWeekday = (): UseWeekdayHook => {
  const { t } = useCustomTranslation()

  const translatedWeekdaysShort: Record<Day, string> = {
    mo: t('common.mondayShort'),
    tu: t('common.tuesdayShort'),
    we: t('common.wednesdayShort'),
    th: t('common.thursdayShort'),
    fr: t('common.fridayShort'),
    sa: t('common.saturdayShort'),
    su: t('common.sundayShort'),
  }

  const translatedWeekdaysLong: Record<Day, string> = {
    mo: t('common.monday'),
    tu: t('common.tuesday'),
    we: t('common.wednesday'),
    th: t('common.thursday'),
    fr: t('common.friday'),
    sa: t('common.saturday'),
    su: t('common.sunday'),
  }

  return { translatedWeekdaysShort, translatedWeekdaysLong }
}
